import e, { Component as t } from "react";
import n from "react-dom";
import { InputText as i } from "../InputText/InputText.js";
import s from "../../../../node_modules/classnames/index.js";
import r from "../../../utils/ObjectUtils.js";
import { FormLabel as o } from "../Label/FormLabel.js";
import { tip as u } from "../Tooltip/Tooltip.js";
import { Icon as l } from "../../general/Icon/Icon.js";
import { DELETE as a, BACKSPACE as p, ENTER as c, RIGHT as h, LEFT as d, DOWN as m, UP as f } from "../../../constants/keyboard.js";
import { componentName as g } from "../../../utils/bem/index.js";
import "../../../../node_modules/underscore/modules/index-default.js";
import "../../../../node_modules/underscore/modules/_setup.js";
import "../../../../node_modules/underscore/modules/isFunction.js";
import "../../../../node_modules/underscore/modules/_stringTagBug.js";
import "../../../../node_modules/underscore/modules/isArguments.js";
import "../../../../node_modules/underscore/modules/underscore.js";
import "../../../../node_modules/underscore/modules/isMap.js";
import "../../../../node_modules/underscore/modules/isWeakMap.js";
import "../../../../node_modules/underscore/modules/isSet.js";
import "../../../../node_modules/underscore/modules/toPath.js";
import "../../../../node_modules/underscore/modules/iteratee.js";
import "../../../../node_modules/underscore/modules/escape.js";
import "../../../../node_modules/underscore/modules/unescape.js";
import "../../../../node_modules/underscore/modules/templateSettings.js";
import v from "../../../../node_modules/underscore/modules/uniqueId.js";
import "../../../../node_modules/underscore/modules/partial.js";
import "../../../../node_modules/underscore/modules/bind.js";
import "../../../../node_modules/underscore/modules/bindAll.js";
import "../../../../node_modules/underscore/modules/delay.js";
import "../../../../node_modules/underscore/modules/defer.js";
import "../../../../node_modules/underscore/modules/once.js";
import "../../../../node_modules/underscore/modules/invoke.js";
import "../../../../node_modules/underscore/modules/pick.js";
import "../../../../node_modules/underscore/modules/omit.js";
import "../../../../node_modules/underscore/modules/without.js";
import "../../../../node_modules/underscore/modules/union.js";
import "../../../../node_modules/underscore/modules/difference.js";
import "../../../../node_modules/underscore/modules/zip.js";
import "../../../../node_modules/underscore/modules/underscore-array-methods.js";
function y(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function b(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function _(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function x(e) {
  return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function E(e, t) {
  return (E = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var D = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && E(e, t);
  }(S, t);
  var v,
    D,
    w,
    I = (v = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = x(S);
      if (v) {
        var i = x(this).constructor;
        t = Reflect.construct(n, arguments, i);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : y(this);
    });
  function S(e) {
    var t;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, S), _(y(t = I.call(this, e)), "numberFormat", void 0), _(y(t), "_numeral", void 0), _(y(t), "_decimal", void 0), _(y(t), "_group", void 0), _(y(t), "_minusSign", void 0), _(y(t), "_currency", void 0), _(y(t), "_suffix", void 0), _(y(t), "_prefix", void 0), _(y(t), "_index", void 0), _(y(t), "groupChar", void 0), _(y(t), "prefixChar", void 0), _(y(t), "suffixChar", void 0), _(y(t), "timer", void 0), _(y(t), "inputEl", void 0), _(y(t), "isSpecialChar", void 0), _(y(t), "lastValue", void 0), _(y(t), "tooltip", void 0), _(y(t), "element", void 0), _(y(t), "onUpButtonMouseDown", function (e) {
      t.props.disabled || (t.inputEl.focus(), t.repeat(e, null, 1), e.preventDefault());
    }), _(y(t), "onUpButtonMouseUp", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onUpButtonMouseLeave", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onUpButtonKeyUp", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onUpButtonKeyDown", function (e) {
      (32 === e.keyCode || 13 === e.keyCode) && t.repeat(e, null, 1);
    }), _(y(t), "onDownButtonMouseDown", function (e) {
      t.props.disabled || (t.inputEl.focus(), t.repeat(e, null, -1), e.preventDefault());
    }), _(y(t), "onDownButtonMouseUp", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onDownButtonMouseLeave", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onDownButtonKeyUp", function () {
      t.props.disabled || t.clearTimer();
    }), _(y(t), "onDownButtonKeyDown", function (e) {
      (32 === e.keyCode || 13 === e.keyCode) && t.repeat(e, null, -1);
    }), _(y(t), "onInput", function (e) {
      var n = e.target;
      t.isSpecialChar && (n.value = t.lastValue), t.isSpecialChar = !1;
    }), _(y(t), "onInputKeyDown", function (e) {
      var n = e.target;
      if (t.lastValue = n.value, e.shiftKey || e.altKey) {
        t.isSpecialChar = !0;
        return;
      }
      var i = n.selectionStart,
        s = n.selectionEnd,
        r = n.value,
        o = null;
      switch (e.which) {
        case f:
          t.spin(e, 1), e.preventDefault();
          break;
        case m:
          t.spin(e, -1), e.preventDefault();
          break;
        case d:
          var u = r.charAt(i - 1);
          t.isNumeralChar(u) || e.preventDefault();
          break;
        case h:
          var l = r.charAt(i);
          t.isNumeralChar(l) || e.preventDefault();
          break;
        case c:
          o = t.validateValue(t.parseValue(r)), t.inputEl.value = t.formatValue(o), t.inputEl.setAttribute("aria-valuenow", o), t.updateModel(e, o);
          break;
        case p:
          if (e.preventDefault(), i === s) {
            var g = r.charAt(i - 1),
              v = r.search(t._decimal);
            if (t._decimal.lastIndex = 0, t.isNumeralChar(g)) {
              if (t._group.test(g)) t._group.lastIndex = 0, o = r.slice(0, i - 2) + r.slice(i - 1);else if (t._decimal.test(g)) t._decimal.lastIndex = 0, o = r.slice(0, i - 1) + r.slice(i);else if (v > 0 && i > v) o = r.slice(0, i - 1) + r.slice(i);else if (v > 0 && 1 === v) {
                o = r.slice(0, i - 1) + r.slice(i);
                var y = t.parseValue(o);
                o = "number" == typeof y && y > 0 ? o : "";
              } else o = r.slice(0, i - 1) + r.slice(i);
            }
            t.updateValue(e, o, null, "delete-single");
          } else o = t.deleteRange(r, i, s), t.updateValue(e, o, null, "delete-range");
          break;
        case a:
          if (e.preventDefault(), i === s) {
            var b = r.charAt(i),
              _ = r.search(t._decimal);
            if (t._decimal.lastIndex = 0, t.isNumeralChar(b)) {
              if (t._group.test(b)) t._group.lastIndex = 0, o = r.slice(0, i) + r.slice(i + 2);else if (t._decimal.test(b)) t._decimal.lastIndex = 0, o = r.slice(0, i) + r.slice(i + 1);else if (_ > 0 && i > _) o = r.slice(0, i) + r.slice(i + 1);else if (_ > 0 && 1 === _) {
                o = r.slice(0, i) + r.slice(i + 1);
                var x = t.parseValue(o);
                o = "number" == typeof x && x > 0 ? o : "";
              } else o = r.slice(0, i) + r.slice(i + 1);
              t.updateValue(e, o, null, "delete-back-single");
            }
          } else o = t.deleteRange(r, i, s), t.updateValue(e, o, null, "delete-range");
      }
      t.props.onKeyDown && t.props.onKeyDown(e);
    }), _(y(t), "onInputKeyPress", function (e) {
      e.preventDefault();
      var n = e.which || e.keyCode,
        i = String.fromCharCode(n),
        s = t.isDecimalSign(i),
        r = t.isMinusSign(i);
      (48 <= n && n <= 57 || r || s) && t.insert(e, i, {
        isDecimalSign: s,
        isMinusSign: r
      });
    }), _(y(t), "onPaste", function (e) {
      e.preventDefault();
      var n = (e.clipboardData || window.clipboardData).getData("Text");
      if (n) {
        var i = t.parseValue(n);
        null != i && t.insert(e, i.toString());
      }
    }), _(y(t), "onInputClick", function () {
      t.initCursor();
    }), _(y(t), "handleOnChange", function (e, n, i) {
      t.props.onChange && t.isValueChanged(n, i) && t.props.onChange({
        originalEvent: e,
        value: i
      });
    }), _(y(t), "onInputFocus", function (e) {
      var n,
        i,
        s = null !== (n = t.inputEl) && void 0 !== n ? n : e.target,
        r = null !== (i = t.validateValue(t.parseValue(s.value))) && void 0 !== i ? i : "";
      t.isDecimalSign(",") && (r = r.toString().replace(".", ",")), s.value = r.toString(), t.setState({
        focused: !0
      }, function () {
        t.props.onFocus && t.props.onFocus(e);
      });
    }), _(y(t), "onInputBlur", function (e) {
      e.persist();
      var n = t.inputEl.value.replace(t._decimal, "."),
        i = n ? t.formatValue(n) : n,
        s = t.validateValue(t.parseValue(i));
      t.updateInputValue(s), t.updateModel(e, s), t.handleOnChange(e, n, s), t.setState({
        focused: !1
      }, function () {
        t.props.onBlur && t.props.onBlur(e);
      });
    }), t.state = {
      focused: !1
    }, t.constructParser(), t;
  }
  return D = [{
    key: "getOptions",
    value: function value() {
      return {
        localeMatcher: this.props.localeMatcher,
        style: this.props.mode,
        currency: this.props.currency,
        currencyDisplay: this.props.currencyDisplay,
        useGrouping: this.props.useGrouping,
        minimumFractionDigits: this.props.minFractionDigits,
        maximumFractionDigits: this.props.maxFractionDigits
      };
    }
  }, {
    key: "constructParser",
    value: function value() {
      this.numberFormat = new Intl.NumberFormat(this.props.locale, this.getOptions());
      var e = Array.from(new Intl.NumberFormat(this.props.locale, {
          useGrouping: !1
        }).format(9876543210)).reverse(),
        t = new Map(e.map(function (e, t) {
          return [e, t];
        }));
      this._numeral = RegExp("[".concat(e.join(""), "]"), "g"), this._decimal = this.getDecimalExpression(), this._group = this.getGroupingExpression(), this._minusSign = this.getMinusSignExpression(), this._currency = this.getCurrencyExpression(), this._suffix = this.getSuffixExpression(), this._prefix = this.getPrefixExpression(), this._index = function (e) {
        return t.get(e).toString();
      };
    }
  }, {
    key: "escapeRegExp",
    value: function value(e) {
      return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    }
  }, {
    key: "getDecimalExpression",
    value: function value() {
      var e = new Intl.NumberFormat(this.props.locale, {
        useGrouping: !1
      });
      return RegExp("[".concat(e.format(1.1).trim().replace(this._numeral, ""), "]"), "g");
    }
  }, {
    key: "getGroupingExpression",
    value: function value() {
      var e = new Intl.NumberFormat(this.props.locale, {
        useGrouping: !0
      });
      return this.groupChar = e.format(1e6).trim().replace(this._numeral, "").charAt(0), RegExp("[".concat(this.groupChar, "]"), "g");
    }
  }, {
    key: "getMinusSignExpression",
    value: function value() {
      var e = new Intl.NumberFormat(this.props.locale, {
        useGrouping: !1
      });
      return RegExp("[".concat(e.format(-1).trim().replace(this._numeral, ""), "]"), "g");
    }
  }, {
    key: "getCurrencyExpression",
    value: function value() {
      if (!this.props.currency) return /[]/g;
      var e = new Intl.NumberFormat(this.props.locale, {
        style: "currency",
        currency: this.props.currency,
        currencyDisplay: this.props.currencyDisplay
      });
      return RegExp("[".concat(e.format(1).replace(/\s/g, "").replace(this._numeral, "").replace(this._decimal, "").replace(this._group, ""), "]"), "g");
    }
  }, {
    key: "getPrefixExpression",
    value: function value() {
      if (this.props.prefix) this.prefixChar = this.props.prefix;else {
        var e = new Intl.NumberFormat(this.props.locale, {
          style: this.props.mode,
          currency: this.props.currency,
          currencyDisplay: this.props.currencyDisplay
        });
        this.prefixChar = e.format(1).split("1")[0];
      }
      return RegExp("".concat(this.escapeRegExp(this.prefixChar || "")), "g");
    }
  }, {
    key: "getSuffixExpression",
    value: function value() {
      if (this.props.suffix) this.suffixChar = this.props.suffix;else {
        var e = new Intl.NumberFormat(this.props.locale, {
          style: this.props.mode,
          currency: this.props.currency,
          currencyDisplay: this.props.currencyDisplay,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        this.suffixChar = e.format(1).split("1")[1];
      }
      return RegExp("".concat(this.escapeRegExp(this.suffixChar || "")), "g");
    }
  }, {
    key: "formatValue",
    value: function value(e) {
      if (null != e) {
        if (this.props.format) {
          var t = new Intl.NumberFormat(this.props.locale, this.getOptions()).format(+e);
          return this.props.prefix && (t = this.props.prefix + t), this.props.suffix && (t += this.props.suffix), t;
        }
        return e.toString();
      }
      return "";
    }
  }, {
    key: "parseValue",
    value: function value(e) {
      var t = e.replace(this._suffix, "").replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").replace(this._group, "").replace(this._minusSign, "-").replace(this._decimal, ".").replace(this._numeral, this._index);
      if (t) {
        if ("-" === t) return t;
        var n = +t;
        return isNaN(n) ? null : n;
      }
      return null;
    }
  }, {
    key: "repeat",
    value: function value(e, t, n) {
      var i = this;
      this.clearTimer(), this.timer = setTimeout(function () {
        i.repeat(e, 40, n);
      }, t || 500), this.spin(e, n);
    }
  }, {
    key: "spin",
    value: function value(e, t) {
      var n,
        i = this.props.step * t,
        s = this.parseValue(this.inputEl.value) || 0;
      n = "string" == typeof s ? +(s + i.toString()) : s + i;
      var r = this.validateValue(n);
      this.updateInput(r, null, "spin"), this.updateModel(e, r), this.handleOnChange(e, s, r);
    }
  }, {
    key: "allowMinusSign",
    value: function value() {
      return null === this.props.min || this.props.min < 0;
    }
  }, {
    key: "isMinusSign",
    value: function value(e) {
      return !!this._minusSign.test(e) && (this._minusSign.lastIndex = 0, !0);
    }
  }, {
    key: "isDecimalSign",
    value: function value(e) {
      return !!this._decimal.test(e) && (this._decimal.lastIndex = 0, !0);
    }
  }, {
    key: "insert",
    value: function value(e, t) {
      var n,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          isDecimalSign: !1,
          isMinusSign: !1
        },
        s = t.search(this._minusSign);
      if (this._minusSign.lastIndex = 0, this.allowMinusSign() || -1 === s) {
        var r = this.inputEl.selectionStart,
          o = this.inputEl.selectionEnd,
          u = this.inputEl.value.trim(),
          l = u.search(this._decimal);
        this._decimal.lastIndex = 0;
        var a = u.search(this._minusSign);
        if (this._minusSign.lastIndex = 0, i.isMinusSign) 0 === r && (n = u, (-1 === a || 0 !== o) && (n = this.insertText(u, t, 0, o)), this.updateValue(e, n, t, "insert"));else if (i.isDecimalSign) l < 0 ? (n = u.slice(0, r) + t + u.slice(o), this.updateValue(e, n, t, "insert")) : l > r && l < o ? (n = this.insertText(u, t, r, o), this.updateValue(e, n, t, "insert")) : r === o && (n = u.slice(0, r).replace(this._decimal, "") + t + u.slice(o).replace(this._decimal, ""), this.updateValue(e, n, t, "insert"));else {
          var p = this.numberFormat.resolvedOptions().maximumFractionDigits,
            c = r !== o ? "range-insert" : "insert";
          l > 0 && r > l ? r + t.length - (l + 1) <= p && (n = u.slice(0, r) + t + u.slice(o), this.updateValue(e, n, t, c)) : (n = this.insertText(u, t, r, o), this.updateValue(e, n, t, c));
        }
      }
    }
  }, {
    key: "insertText",
    value: function value(e, t, n, i) {
      if (2 !== t.split(".").length || this.isDecimalSign(t)) return i - n === e.length ? t : 0 === n ? t + e.slice(i) : i === e.length ? e.slice(0, n) + t : e.slice(0, n) + t + e.slice(i);
      var s = e.slice(n, i).search(this._decimal);
      return this._decimal.lastIndex = 0, s > 0 ? e.slice(0, n) + this.formatValue(t) + e.slice(i) : e || this.formatValue(t);
    }
  }, {
    key: "deleteRange",
    value: function value(e, t, n) {
      return n - t === e.length ? "" : 0 === t ? e.slice(n) : n === e.length ? e.slice(0, t) : e.slice(0, t) + e.slice(n);
    }
  }, {
    key: "initCursor",
    value: function value() {
      var e = this.inputEl.selectionStart,
        t = this.inputEl.value,
        n = t.length,
        i = null,
        s = t.charAt(e);
      if (!this.isNumeralChar(s)) {
        for (var r = e - 1; r >= 0;) {
          if (s = t.charAt(r), this.isNumeralChar(s)) {
            i = r;
            break;
          }
          r--;
        }
        if (null !== i) this.inputEl.setSelectionRange(i + 1, i + 1);else {
          for (r = e + 1; r < n;) {
            if (s = t.charAt(r), this.isNumeralChar(s)) {
              i = r;
              break;
            }
            r++;
          }
          null !== i && this.inputEl.setSelectionRange(i, i);
        }
      }
    }
  }, {
    key: "isNumeralChar",
    value: function value(e) {
      return !!(1 === e.length && (this._numeral.test(e) || this._decimal.test(e) || this._group.test(e) || this._minusSign.test(e))) && (this.resetRegex(), !0);
    }
  }, {
    key: "resetRegex",
    value: function value() {
      this._numeral.lastIndex = 0, this._decimal.lastIndex = 0, this._group.lastIndex = 0, this._minusSign.lastIndex = 0;
    }
  }, {
    key: "updateValue",
    value: function value(e, t, n, i) {
      var s = this.inputEl.value;
      this.updateInput(t, n, i), this.handleOnChange(e, s, t);
    }
  }, {
    key: "isValueChanged",
    value: function value(e, t) {
      return null === t && null !== e || null != t && t !== ("string" == typeof e ? this.parseValue(e) : e);
    }
  }, {
    key: "validateValue",
    value: function value(e) {
      return null !== this.props.min && +e < this.props.min ? this.props.min : null !== this.props.max && +e > this.props.max ? this.props.max : e;
    }
  }, {
    key: "updateInput",
    value: function value(e, t, n) {
      t = t || "";
      var i = this.inputEl.value,
        s = null !== e ? e.toString() : "",
        r = i.length;
      if (0 === r) {
        this.inputEl.value = s, this.inputEl.setSelectionRange(0, 0), this.initCursor();
        var o = (this.prefixChar || "").length + t.length;
        this.inputEl.setSelectionRange(o, o);
      } else {
        var u = this.inputEl.selectionStart,
          l = this.inputEl.selectionEnd;
        this.inputEl.value = s;
        var a = s.length;
        if ("range-insert" === n) {
          var p = this.parseValue((i || "").slice(0, u)),
            c = RegExp((null !== p ? p.toString() : "").split("").join("(".concat(this.groupChar, ")?")), "g");
          c.test(s);
          var h = RegExp(t.split("").join("(".concat(this.groupChar, ")?")), "g");
          h.test(s.slice(c.lastIndex)), l = c.lastIndex + h.lastIndex, this.inputEl.setSelectionRange(l, l);
        } else if (a === r) "insert" === n || "delete-back-single" === n ? this.inputEl.setSelectionRange(l + 1, l + 1) : "delete-single" === n ? this.inputEl.setSelectionRange(l - 1, l - 1) : ("delete-range" === n || "spin" === n) && this.inputEl.setSelectionRange(l, l);else if ("delete-back-single" === n) {
          var d = i.charAt(l - 1),
            m = i.charAt(l),
            f = r - a,
            g = this._group.test(m);
          g && 1 === f ? l += 1 : !g && this.isNumeralChar(d) && (l += -1 * f + 1), this._group.lastIndex = 0, this.inputEl.setSelectionRange(l, l);
        } else l += a - r, this.inputEl.setSelectionRange(l, l);
      }
      this.inputEl.setAttribute("aria-valuenow", s);
    }
  }, {
    key: "updateInputValue",
    value: function value(e) {
      this.inputEl.value = this.formatValue(e), this.inputEl.setAttribute("aria-valuenow", null == e ? void 0 : e.toString());
    }
  }, {
    key: "updateModel",
    value: function value(e, t) {
      this.props.onValueChange && this.props.onValueChange({
        originalEvent: e,
        value: t,
        target: {
          name: this.props.name,
          id: this.props.id,
          value: t
        }
      });
    }
  }, {
    key: "clearTimer",
    value: function value() {
      this.timer && clearInterval(this.timer);
    }
  }, {
    key: "getInputMode",
    value: function value() {
      return this.props.inputMode || ("decimal" !== this.props.mode || this.props.minFractionDigits ? "decimal" : "numeric");
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.props.tooltip && this.renderTooltip();
      var e = this.validateValue(this.props.value);
      this.props.value !== e && this.updateModel(null, e);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      e.tooltip !== this.props.tooltip && (this.tooltip ? this.tooltip.updateContent(this.props.tooltip) : this.renderTooltip());
      var t = this.isOptionChanged(e);
      if (t && this.constructParser(), e.value !== this.props.value || t) {
        var n = this.validateValue(this.props.value);
        this.state.focused ? this.inputEl.value = null !== n ? n.toString() : "" : this.updateInputValue(n), this.props.value !== n && this.updateModel(null, n);
      }
    }
  }, {
    key: "isOptionChanged",
    value: function value(e) {
      var t = this;
      return ["locale", "localeMatcher", "mode", "currency", "currencyDisplay", "useGrouping", "minFractionDigits", "maxFractionDigits", "suffix", "prefix"].some(function (n) {
        return e[n] !== t.props[n];
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.tooltip && (this.tooltip.destroy(), this.tooltip = null);
    }
  }, {
    key: "renderTooltip",
    value: function value() {
      this.tooltip = u({
        target: this.element,
        content: this.props.tooltip,
        options: this.props.tooltipOptions
      });
    }
  }, {
    key: "renderInputElement",
    value: function value() {
      var t,
        s,
        o = this,
        u = this.formatValue(this.props.value),
        l = r.findDiffKeys(this.props, S.defaultProps);
      return e.createElement(i, (t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {},
            i = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), i.forEach(function (t) {
            _(e, t, n[t]);
          });
        }
        return e;
      }({}, l), s = s = {
        ref: function ref(e) {
          return o.inputEl = n.findDOMNode(e);
        },
        id: this.props.inputId,
        hasError: !!this.props.errorMessage,
        role: "spinbutton",
        className: this.props.inputClassName,
        defaultValue: u,
        type: this.props.type,
        size: this.props.size,
        tabIndex: this.props.tabIndex,
        inputMode: this.getInputMode(),
        disabled: this.props.disabled,
        required: this.props.required,
        pattern: this.props.pattern,
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        name: this.props.name,
        onKeyDown: this.onInputKeyDown,
        onKeyPress: this.onInputKeyPress,
        onInput: this.onInput,
        onClick: this.onInputClick,
        onBlur: this.onInputBlur,
        onFocus: this.onInputFocus,
        onPaste: this.onPaste,
        min: this.props.min,
        max: this.props.max,
        "aria-valuemin": this.props.min,
        "aria-valuemax": this.props.max,
        "aria-valuenow": this.props.value,
        "aria-labelledby": this.props.ariaLabelledBy,
        autoSelect: this.props.autoSelect
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(s)) : function (e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          n.push.apply(n, i);
        }
        return n;
      }(Object(s)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(s, e));
      }), t));
    }
  }, {
    key: "renderUpButton",
    value: function value() {
      var t = s("input-number__increment-button", this.props.incrementButtonClassName);
      return e.createElement("button", {
        type: "button",
        className: t,
        onMouseLeave: this.onUpButtonMouseLeave,
        onMouseDown: this.onUpButtonMouseDown,
        onMouseUp: this.onUpButtonMouseUp,
        onKeyDown: this.onUpButtonKeyDown,
        onKeyUp: this.onUpButtonKeyUp,
        disabled: this.props.disabled,
        tabIndex: -1
      }, e.createElement(l, {
        solid: !0,
        fw: !0,
        name: this.props.incrementButtonIcon,
        className: "input-number__icon"
      }));
    }
  }, {
    key: "renderDownButton",
    value: function value() {
      var t = s("input-number__decrement-button", this.props.idecrementButtonClassName);
      return e.createElement("button", {
        type: "button",
        className: t,
        onMouseLeave: this.onDownButtonMouseLeave,
        onMouseDown: this.onDownButtonMouseDown,
        onMouseUp: this.onDownButtonMouseUp,
        onKeyDown: this.onDownButtonKeyDown,
        onKeyUp: this.onDownButtonKeyUp,
        disabled: this.props.disabled,
        tabIndex: -1
      }, e.createElement(l, {
        solid: !0,
        fw: !0,
        name: this.props.decrementButtonIcon,
        className: "input-number__icon"
      }));
    }
  }, {
    key: "renderButtonGroup",
    value: function value() {
      var t = this.props.showButtons && this.renderUpButton(),
        n = this.props.showButtons && this.renderDownButton();
      return e.createElement("span", {
        className: "input-number__button-group"
      }, t, n);
    }
  }, {
    key: "renderInputWithButtons",
    value: function value() {
      var t = this.renderUpButton(),
        n = this.renderDownButton(),
        i = this.renderInputElement();
      return "stacked" === this.props.buttonLayout ? e.createElement(e.Fragment, null, i, e.createElement("span", {
        className: "input-number__button-group"
      }, t, n)) : e.createElement(e.Fragment, null, n, i, t);
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
        n = g("input-number", this.props.className, {
          horizontal: "horizontal" === this.props.buttonLayout,
          stacked: "stacked" === this.props.buttonLayout
        });
      return e.createElement(o, {
        className: n,
        value: this.props.label,
        errorMessage: this.props.errorMessage,
        isRequired: this.props.required,
        htmlFor: this.props.inputId
      }, e.createElement("span", {
        ref: function ref(e) {
          return t.element = e;
        },
        className: "input-number__inner"
      }, this.props.showButtons ? this.renderInputWithButtons() : this.renderInputElement()));
    }
  }], b(S.prototype, D), w && b(S, w), S;
}(t);
_(D, "defaultProps", {
  value: null,
  format: !0,
  autoSelect: !1,
  showButtons: !1,
  buttonLayout: "stacked",
  incrementButtonClassName: null,
  decrementButtonClassName: null,
  incrementButtonIcon: "chevron-up",
  decrementButtonIcon: "chevron-down",
  mode: "decimal",
  suffix: null,
  prefix: null,
  step: 1,
  min: null,
  max: null,
  useGrouping: !0,
  size: null,
  className: null,
  inputId: v(),
  inputClassName: null,
  tooltip: null,
  tooltipOptions: null,
  ariaLabelledBy: null,
  label: null,
  errorMessage: null,
  onValueChange: null,
  onChange: null
});
export { D as InputNumber };